
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/corporate-governance",
      function () {
        return require("private-next-pages/about-us/corporate-governance.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/corporate-governance"])
      });
    }
  